// Persistencia local del draft del checklist de mantención (offline real, v1).
// Snapshot por mantención en localStorage. Todo best-effort: si localStorage
// falla (quota/disabled/privado), las funciones degradan a no-op / null sin
// lanzar, así el flujo en memoria sigue funcionando.

const KEY_PREFIX = 'prolift:mantencion-draft:v1:';
const keyFor = (id) => `${KEY_PREFIX}${id}`;

export function saveDraft(id, draft) {
  if (id == null) return;
  try {
    const payload = JSON.stringify({ ...draft, updatedAt: Date.now() });
    localStorage.setItem(keyFor(id), payload);
  } catch {
    // best-effort: quota / disabled
  }
}

export function loadDraft(id) {
  if (id == null) return null;
  try {
    const raw = localStorage.getItem(keyFor(id));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function hasDraft(id) {
  if (id == null) return false;
  try {
    return localStorage.getItem(keyFor(id)) != null;
  } catch {
    return false;
  }
}

export function clearDraft(id) {
  if (id == null) return;
  try {
    localStorage.removeItem(keyFor(id));
  } catch {
    // best-effort
  }
}

export function listDraftIds() {
  const ids = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(KEY_PREFIX)) {
        ids.push(key.slice(KEY_PREFIX.length));
      }
    }
  } catch {
    // best-effort
  }
  return ids;
}
